import { render } from "./BaseDialogDeleteConfirmation.vue?vue&type=template&id=e3e9b2be"
import script from "./BaseDialogDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./BaseDialogDeleteConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__